import { render, staticRenderFns } from "./CustomWizard.vue?vue&type=template&id=5cf6015d&scoped=true"
import script from "./CustomWizard.vue?vue&type=script&lang=js"
export * from "./CustomWizard.vue?vue&type=script&lang=js"
import style0 from "./CustomWizard.vue?vue&type=style&index=0&id=5cf6015d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6015d",
  null
  
)

export default component.exports